module.exports = __webpack_public_path__ + "fonts/b7bd0884175754a3ae74abb98085e252.txt";